import {
  ProjectBankStatementPeriodDetail,
  ProjectBankStatementLineRow,
} from '../../api/incomeExpenseApi';
import * as XLSX from 'xlsx';
import { sanitizeExportFilename } from '../../utils/excelExport';

const formatExportDateTime = (value: string) => new Date(value).toLocaleString('vi-VN');

const formatAmount = (n: number | null | undefined) =>
  n != null && n !== 0 ? Math.round(n) : '';

const statusExportLabel: Record<string, string> = {
  MATCHED: 'Đã khớp',
  UNMATCHED: 'Chưa khớp',
  IGNORED: 'Bỏ qua',
};

const LINE_HEADERS = [
  'STT',
  'Ngày giao dịch',
  'Số giao dịch',
  'Nội dung',
  'Số tiền gửi',
  'Số tiền rút',
  'Số dư',
  'Trạng thái',
  'Số bút toán ghép',
  'Ghi chú',
];

function mapLineRow(line: ProjectBankStatementLineRow): (string | number)[] {
  return [
    line.sortOrder,
    formatExportDateTime(line.transactionAt),
    line.bankReference || '',
    line.content,
    formatAmount(line.depositAmount),
    formatAmount(line.withdrawalAmount),
    formatAmount(line.runningBalance),
    statusExportLabel[line.status] || line.status,
    line.matchedLedger?.journalNumber || '',
    line.notes || '',
  ];
}

export function exportBankStatementPeriodReport(params: {
  accountName: string;
  detail: ProjectBankStatementPeriodDetail;
}): void {
  const { accountName, detail } = params;
  const periodLabel = `${String(detail.periodMonth).padStart(2, '0')}-${detail.periodYear}`;

  const metaRows: (string | number)[][] = [
    ['Sổ phụ tài khoản', accountName],
    ['Kỳ sao kê', `${detail.periodMonth}/${detail.periodYear}`],
    [
      'Số tài khoản',
      detail.statementBankAccountNumber || detail.projectBankAccount.bankAccountNumber || '',
    ],
    ['Số dư đầu kỳ', formatAmount(detail.openingBalance)],
    ['Số dư cuối kỳ', formatAmount(detail.closingBalance)],
    [
      'Cộng phát sinh trong kỳ — Rút',
      formatAmount(detail.periodTotalWithdrawal),
      'Gửi',
      formatAmount(detail.periodTotalDeposit),
    ],
    ['Đã khớp', detail.summary.matchedInBank],
    ['Chưa khớp', detail.summary.unmatchedInBank],
    ['Thiếu trên hệ thống', detail.summary.missedInSystem],
    ['Thiếu trên sao kê', detail.summary.missedInBank],
    [],
    LINE_HEADERS,
  ];

  const dataRows = detail.lines.map(mapLineRow);
  const filename = `${sanitizeExportFilename(`so-phu_${accountName}_${periodLabel}`)}.xlsx`;
  const ws = XLSX.utils.aoa_to_sheet([...metaRows, ...dataRows]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sổ phụ');
  const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}
